import { MenuSettings } from './menu-settings';

export enum BookmarkActions {
  Create = 'created',
  Update = 'updated',
  Delete = 'deleted',
  Rename = 'renamed',
  Apply = 'applied'
}

export interface BookmarkMenuSettings extends MenuSettings {
  warnings?: { isOrphan?: boolean; needsReview?: boolean };
}

export const BookmarkMenuItems = {
  AddBookmark: {
    name: 'addBookmark',
    icon: 'plus-sign',
    text: 'Add Bookmark'
  },
  Default: {
    name: 'defaultBookmark',
    text: 'Make Default'
  },
  Apply: {
    name: 'applyBookmark',
    text: 'Apply'
  },
  Rename: {
    name: 'renameBookmark',
    text: 'Rename'
  },
  Update: {
    name: 'updateBookmark',
    text: 'Update'
  },
  ClearDefault: {
    name: 'clearDefaultBookmark',
    text: 'Clear Default'
  },
  Delete: {
    name: 'deleteBookmark',
    text: 'Delete'
  }
};
